import { render } from "./FlexibleStakingView.vue?vue&type=template&id=1f632c70"
import script from "./FlexibleStakingView.vue?vue&type=script&lang=js"
export * from "./FlexibleStakingView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__